import { BarsOutlined, CloudUploadOutlined, CoffeeOutlined, RollbackOutlined } from '@ant-design/icons';
import { PageHeader } from '@ant-design/pro-components';
import { Button, Col, Descriptions, Divider, Flex, Row, Spin, Steps } from 'antd';
import Input from 'antd/es/input/Input';
import { observer } from 'mobx-react';
import React, { ClipboardEvent, MouseEvent } from "react";
import Subjects from '../../models/subjects';
import { useStore } from '../../stores/root-store';
import SourceFilter from '../common/filters/source-filter';
import '../common/filters/style.css';
import TagsEditor from '../common/filters/tags-editor';
import ImageUploader from '../common/image-uploader';
import NumberInKimWithTheme from '../common/number-in-kim-with-theme';
import handleKeybordPhotoPaste from '../common/photo-paste-helper';
import CloneCard from './clone-card';

const NewTaskPanel: React.FC<{ subject: Subjects }> = ({ subject }) => {

    const { subjectStores } = useStore();

    const newTask = subjectStores[subject].newTask;
    const newTicket = subjectStores[subject].newTicket;
    const ticketBar = subjectStores[subject].ticketBar;

    const tagsStore = { data: newTask.tags };
    const sourceStore = { source: newTask.source };
    const numberInKimWithTheme = { numberWithTheme: newTask.numberInKimWithTheme };
    const photoUploaderStore = { uploader: newTask.photoUploader };
    const solutionUploaderStore = { uploader: newTask.solutionUploader };

    const handleClickSave = () => {
        newTask.createTask();
        handleOnChangeStep(1);
    }

    const handlePaste = (event: ClipboardEvent<HTMLDivElement>) => {
        handleKeybordPhotoPaste(event, photoUploaderStore.uploader, solutionUploaderStore.uploader, () => newTask.loadClones());
    };

    const handleOnChangeStep = (value: number) => {
        newTask.changeStep(value);
        newTask.photoUploader.changeActivated(value === 1);
        newTask.solutionUploader.changeActivated(value === 2);
    }

    const handleReset = () => {
        newTask.reset();
    }

    const handleChangeAnswer = (event: React.ChangeEvent<HTMLInputElement>) => {
        newTask.changeAnswer(event.target.value);
    }

    const handleTicketAction = (event: MouseEvent<HTMLAnchorElement>) => {

        if (newTask.id) {

            if (newTicket.contains(newTask.id)) {
                newTicket.deleteTaskFromList(newTask.id, ticketBar);
            } else {
                newTicket.addTaskInList(newTask.id, ticketBar);
            }
        }
    }

    const spinBlock = <Row gutter={8}>
        <Col span={8} className="center-block">
            <Spin size='large' />
        </Col>
    </Row>;

    const newTaskBlock = <Row gutter={8}>
        {newTask.id
            ? <Col span={8}>
                <Descriptions bordered={true} column={1}>
                    <Descriptions.Item label="Источник">{newTask.savedTask?.source}</Descriptions.Item>
                    <Descriptions.Item label="Тема">{newTask.savedTask?.theme}</Descriptions.Item>
                    <Descriptions.Item label="Номер в КИМ">{newTask.savedTask?.numberInKim}</Descriptions.Item>
                    <Descriptions.Item label="Метки">{newTask.savedTask?.tags}</Descriptions.Item>
                    <Descriptions.Item label="Ответ">{newTask.savedTask?.answer}</Descriptions.Item>
                </Descriptions>
                <Button type='link' onClick={handleTicketAction} style={{ marginTop: "10px" }}>
                    {newTicket.contains(newTask.id) ? "Убрать из варианта" : "Добавить в вариант"}
                </Button>
                <Divider />
                <Button key="enter" className="save__button" icon={<RollbackOutlined />} onClick={handleReset}>Создать новую</Button>
            </Col>
            : <Col span={8}>
                <SourceFilter {...sourceStore} />
                <NumberInKimWithTheme {...numberInKimWithTheme} />
                <TagsEditor {...tagsStore} />
                <Input placeholder='ответ' onChange={handleChangeAnswer} style={{ marginTop: "10px", marginBottom: "10px" }} />
                <Button key="enter" className="save__button" type="primary" onClick={handleClickSave}>Далее</Button>
            </Col>
        }
        <Col span={8}>
            <ImageUploader {...photoUploaderStore} callback={() => newTask.loadClones()} />
        </Col>
        <Col span={8}>
            <ImageUploader {...solutionUploaderStore} />
        </Col>
    </Row>;

    return (
        <div>
            <div onPaste={handlePaste}>
                <Steps
                    current={newTask.step}
                    className="steps__block"
                    type="navigation"
                    onChange={handleOnChangeStep}
                >
                    <Steps.Step title="Данные" icon={<BarsOutlined />} />
                    <Steps.Step title="Файлы задачи" icon={<CloudUploadOutlined />} />
                    <Steps.Step title="Файлы решения" icon={<CoffeeOutlined />} />
                </Steps>
                {newTask.loading ? spinBlock : newTaskBlock}
            </div>
            {newTask.taskClones && newTask.taskClones.length > 0 &&
                <div>
                    <Divider />
                    <PageHeader title="Возможные клоны задачи" className="site-page-header" />
                    <Flex wrap="wrap" gap="middle" align="start">
                        {newTask.taskClones.map(t => <CloneCard task={t} key={t.data.id}/>)}
                    </Flex>
                </div>
            }
        </div>
    );
};

export default observer(NewTaskPanel);
